import { render, staticRenderFns } from "./RegisteredDevices.vue?vue&type=template&id=03855a3c&"
import script from "./RegisteredDevices.vue?vue&type=script&lang=js&"
export * from "./RegisteredDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports